// // // export default function LawyerPage() {
// // //   return (
// // //     <div style={{ padding: "120px 20px" }}>
// // //       <h1>Lawyer Page</h1>
// // //       <p>
// // //         Manage clients, track case progress, update hearing statuses, and maintain
// // //         organized records all through one efficient platform built to simplify
// // //         your legal workflow.
// // //       </p>
// // //     </div>
// // //   );
// // // }






















// // // import { motion } from "framer-motion";
// // // import {
// // //   Briefcase,
// // //   Users,
// // //   Clock,
// // //   ShieldCheck,
// // //   FileText,
// // //   Sparkles,
// // //   Gavel,
// // //   FolderKanban,
// // //   UserCheck,
// // //   CalendarClock,
// // //   FileSearch,
// // //   Scale
// // // } from "lucide-react";

// // // const LawyersPage = () => {

// // //   const features = [
// // //     {
// // //       icon: Briefcase,
// // //       title: "Case Management",
// // //       desc: "Track and manage all your legal cases in one structured system."
// // //     },
// // //     {
// // //       icon: Users,
// // //       title: "Client Handling",
// // //       desc: "Maintain complete client records, communication, and history."
// // //     },
// // //     {
// // //       icon: Clock,
// // //       title: "Smart Scheduling",
// // //       desc: "Never miss hearings or deadlines with automated reminders."
// // //     },
// // //     {
// // //       icon: ShieldCheck,
// // //       title: "Secure Platform",
// // //       desc: "End-to-end encrypted system to protect sensitive legal data."
// // //     },
// // //     {
// // //       icon: FileText,
// // //       title: "Legal Documentation",
// // //       desc: "Organize petitions, affidavits, and documents efficiently."
// // //     },
// // //     {
// // //       icon: Sparkles,
// // //       title: "Productivity Boost",
// // //       desc: "Reduce manual work and focus on core legal activities."
// // //     }
// // //   ];

// // //   const workflow = [
// // //     {
// // //       icon: FolderKanban,
// // //       title: "Case Lifecycle Management",
// // //       desc: "Track every stage of a case from filing to judgment with complete clarity."
// // //     },
// // //     {
// // //       icon: UserCheck,
// // //       title: "Client Case Mapping",
// // //       desc: "Connect clients with multiple cases and access their history instantly."
// // //     },
// // //     {
// // //       icon: CalendarClock,
// // //       title: "Court & Hearing Tracking",
// // //       desc: "Stay updated with hearings, schedules, and deadlines."
// // //     },
// // //     {
// // //       icon: FileSearch,
// // //       title: "Document & Evidence Handling",
// // //       desc: "Store and retrieve all legal documents and evidence easily."
// // //     },
// // //     {
// // //       icon: Gavel,
// // //       title: "Courtroom Readiness",
// // //       desc: "Prepare for hearings with quick access to notes and files."
// // //     },
// // //     {
// // //       icon: Scale,
// // //       title: "Practice Efficiency",
// // //       desc: "Focus more on legal strategy instead of administrative work."
// // //     }
// // //   ];

// // //   return (
// // //     <section className="relative w-full bg-[#f8fafc] overflow-hidden">

// // //       {/* Background */}
// // //       <div className="absolute inset-0 opacity-[0.04]"
// // //         style={{
// // //           backgroundImage:
// // //             "radial-gradient(circle at 1px 1px, #cda454 1px, transparent 1px)",
// // //           backgroundSize: "28px 28px"
// // //         }}
// // //       />

// // //       {/* ================= HERO ================= */}
// // //       <div className="max-w-6xl mx-auto px-6 pt-[140px] pb-24 text-center">
// // //         <motion.h1
// // //           initial={{ opacity: 0, y: 40 }}
// // //           animate={{ opacity: 1, y: 0 }}
// // //           className="text-[36px] sm:text-[56px] font-extrabold text-[#111]"
// // //         >
// // //           Designed for
// // //           <span className="block text-[#cda454]">Modern Lawyers</span>
// // //         </motion.h1>

// // //         <p className="mt-6 max-w-2xl mx-auto text-[#555] text-[16px] sm:text-[20px]">
// // //           A complete legal workspace to manage cases, clients, hearings, and documents 
// // //           built specifically for advocates and legal professionals.
// // //         </p>
// // //       </div>

// // //       {/* ================= FEATURE STRIP ================= */}
// // //       <div className="max-w-6xl mx-auto px-6 pb-20">
// // //         <div className="flex flex-wrap justify-center gap-4">
// // //           {["Cases", "Clients", "Hearings", "Documents", "Security"].map((item, i) => (
// // //             <div key={i} className="px-5 py-2 rounded-full bg-white border border-[#cda454]/20 text-sm text-[#333] shadow-sm">
// // //               {item}
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </div>

// // //       {/* ================= FEATURE GRID ================= */}
// // //       <div className="max-w-7xl mx-auto px-6 py-20">
// // //         <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">

// // //           {features.map((item, index) => {
// // //             const Icon = item.icon;
// // //             return (
// // //               <motion.div
// // //                 key={index}
// // //                 initial={{ opacity: 0, y: 60 }}
// // //                 whileInView={{ opacity: 1, y: 0 }}
// // //                 transition={{ duration: 0.6, delay: index * 0.1 }}
// // //                 className="bg-white p-6 rounded-2xl border border-[#cda454]/10
// // //                 shadow-[0_15px_50px_rgba(0,0,0,0.06)]
// // //                 hover:-translate-y-2 transition-all duration-500"
// // //               >
// // //                 <div className="w-12 h-12 rounded-full bg-[#cda454]/15 flex items-center justify-center mb-4">
// // //                   <Icon className="w-5 h-5 text-[#cda454]" />
// // //                 </div>

// // //                 <h3 className="text-[18px] font-semibold text-[#111] mb-2">
// // //                   {item.title}
// // //                 </h3>

// // //                 <p className="text-[#555] text-[14px] sm:text-[16px]">
// // //                   {item.desc}
// // //                 </p>
// // //               </motion.div>
// // //             );
// // //           })}

// // //         </div>
// // //       </div>

// // //       {/* ================= WORKFLOW SECTION ================= */}
// // //       <div className="max-w-7xl mx-auto px-6 py-24">

// // //         <div className="max-w-2xl mb-16">
// // //           <h2 className="text-[30px] sm:text-[42px] font-bold text-[#111]">
// // //             Built Around Real Legal Workflows
// // //           </h2>
// // //           <p className="mt-4 text-[#555]">
// // //             Designed to match how lawyers actually manage cases, clients, and court processes.
// // //           </p>
// // //         </div>

// // //         <div className="relative border-l border-[#cda454]/30 pl-10 space-y-12">

// // //           {workflow.map((item, index) => {
// // //             const Icon = item.icon;

// // //             return (
// // //               <div key={index} className="relative">

// // //                 <span className="absolute -left-[11px] top-2 w-4 h-4 rounded-full bg-[#cda454]" />

// // //                 <div className="bg-white p-6 rounded-2xl
// // //                   border border-[#cda454]/10
// // //                   shadow-[0_10px_40px_rgba(0,0,0,0.06)]
// // //                   hover:-translate-y-1 transition-all duration-300"
// // //                 >
// // //                   <div className="flex items-center gap-3 mb-3">
// // //                     <div className="w-10 h-10 rounded-full bg-[#cda454]/15 flex items-center justify-center">
// // //                       <Icon className="w-5 h-5 text-[#cda454]" />
// // //                     </div>

// // //                     <h3 className="text-[18px] font-semibold text-[#111]">
// // //                       {item.title}
// // //                     </h3>
// // //                   </div>

// // //                   <p className="text-[#555] text-[15px] leading-relaxed">
// // //                     {item.desc}
// // //                   </p>
// // //                 </div>
// // //               </div>
// // //             );
// // //           })}

// // //         </div>
// // //       </div>

// // //       {/* ================= CTA ================= */}
// // //       <div className="max-w-5xl mx-auto px-6 pb-32 text-center">
// // //         <motion.div
// // //           initial={{ opacity: 0, scale: 0.95 }}
// // //           whileInView={{ opacity: 1, scale: 1 }}
// // //           className="bg-white p-12 rounded-3xl border border-[#cda454]/10
// // //           shadow-[0_25px_80px_rgba(0,0,0,0.08)]"
// // //         >
// // //           <h2 className="text-[28px] sm:text-[36px] font-bold text-[#111]">
// // //             Elevate Your Legal Practice
// // //           </h2>

// // //           <p className="mt-4 text-[#555]">
// // //             Simplify your workflow and focus on winning cases, not managing chaos.
// // //           </p>

// // //           <button className="mt-6 px-10 py-3 rounded-full bg-[#111] text-white font-semibold hover:scale-105 transition">
// // //             Get Started
// // //           </button>
// // //         </motion.div>
// // //       </div>

// // //     </section>
// // //   );
// // // };

// // // export default LawyersPage;






























// // import { motion } from "framer-motion";
// // import {
// //   Briefcase,
// //   Users,
// //   Clock,
// //   ShieldCheck,
// //   FileText,
// //   Sparkles,
// //   Gavel,
// //   FolderKanban,
// //   UserCheck,
// //   CalendarClock,
// //   FileSearch,
// //   Scale
// // } from "lucide-react";

// // const LawyersPage = () => {

// //   const features = [
// //     {
// //       icon: Briefcase,
// //       title: "Case Management",
// //       desc: "Track and manage all your legal cases in one structured system."
// //     },
// //     {
// //       icon: Users,
// //       title: "Client Handling",
// //       desc: "Maintain complete client records, communication, and history."
// //     },
// //     {
// //       icon: Clock,
// //       title: "Smart Scheduling",
// //       desc: "Never miss hearings or deadlines with automated reminders."
// //     },
// //     {
// //       icon: ShieldCheck,
// //       title: "Secure Platform",
// //       desc: "End-to-end encrypted system to protect sensitive legal data."
// //     },
// //     {
// //       icon: FileText,
// //       title: "Legal Documentation",
// //       desc: "Organize petitions, affidavits, and documents efficiently."
// //     },
// //     {
// //       icon: Sparkles,
// //       title: "Productivity Boost",
// //       desc: "Reduce manual work and focus on core legal activities."
// //     }
// //   ];

// //   const workflow = [
// //     {
// //       icon: FolderKanban,
// //       title: "Case Lifecycle Management",
// //       desc: "Track every stage of a case from filing to judgment with complete clarity."
// //     },
// //     {
// //       icon: UserCheck,
// //       title: "Client Case Mapping",
// //       desc: "Connect clients with multiple cases and access their history instantly."
// //     },
// //     {
// //       icon: CalendarClock,
// //       title: "Court & Hearing Tracking",
// //       desc: "Stay updated with hearings, schedules, and deadlines."
// //     },
// //     {
// //       icon: FileSearch,
// //       title: "Document & Evidence Handling",
// //       desc: "Store and retrieve all legal documents and evidence easily."
// //     },
// //     {
// //       icon: Gavel,
// //       title: "Courtroom Readiness",
// //       desc: "Prepare for hearings with quick access to notes and files."
// //     },
// //     {
// //       icon: Scale,
// //       title: "Practice Efficiency",
// //       desc: "Focus more on legal strategy instead of administrative work."
// //     }
// //   ];

// //   return (
// //     <section className="relative w-full bg-[#f8fafc] overflow-hidden">

// //       {/* HERO */}
// //       <div className="max-w-6xl mx-auto px-6 pt-[140px] pb-24 text-center">
// //         <h1 className="text-[36px] sm:text-[56px] font-extrabold text-[#111]">
// //           Designed for
// //           <span className="block text-[#cda454]">Modern Lawyers</span>
// //         </h1>

// //         <p className="mt-6 max-w-2xl mx-auto text-[#555] text-[16px] sm:text-[20px]">
// //           A complete legal workspace to manage cases, clients, hearings, and documents.
// //         </p>
// //       </div>

// //       {/* 🔥 VIDEO 1 */}
// //       <div className="max-w-5xl mx-auto px-6 pb-20">
// //         <video
// //           src="/videos/video1.mp4"
// //           autoPlay
// //           loop
// //           muted
// //           className="w-full rounded-3xl shadow-xl"
// //         />
// //       </div>

// //       {/* FEATURE STRIP */}
// //       <div className="max-w-6xl mx-auto px-6 pb-20 flex flex-wrap justify-center gap-4">
// //         {["Cases", "Clients", "Hearings", "Documents", "Security"].map((item, i) => (
// //           <div key={i} className="px-5 py-2 rounded-full bg-white border text-sm">
// //             {item}
// //           </div>
// //         ))}
// //       </div>

// //       {/* FEATURE GRID */}
// //       <div className="max-w-7xl mx-auto px-6 py-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
// //         {features.map((item, i) => {
// //           const Icon = item.icon;
// //           return (
// //             <div key={i} className="bg-white p-6 rounded-2xl border shadow hover:-translate-y-2 transition">
// //               <Icon className="text-[#cda454] mb-3" />
// //               <h3 className="font-semibold">{item.title}</h3>
// //               <p className="text-[#555] text-sm mt-2">{item.desc}</p>
// //             </div>
// //           );
// //         })}
// //       </div>

// //       {/* 🔥 VIDEO 2 */}
// //       <div className="max-w-6xl mx-auto px-6 py-24">
// //         <video
// //           src="/videos/video2.mp4"
// //           autoPlay
// //           loop
// //           muted
// //           className="w-full rounded-3xl shadow-xl"
// //         />
// //       </div>

// //       {/* WORKFLOW */}
// //       <div className="max-w-7xl mx-auto px-6 py-24 space-y-10">
// //         {workflow.map((item, i) => {
// //           const Icon = item.icon;
// //           return (
// //             <div key={i} className="bg-white p-6 rounded-2xl border shadow">
// //               <Icon className="text-[#cda454] mb-2" />
// //               <h3 className="font-semibold">{item.title}</h3>
// //               <p className="text-[#555] text-sm">{item.desc}</p>
// //             </div>
// //           );
// //         })}
// //       </div>

// //       {/* 🔥 VIDEO 3 */}
// //       <div className="max-w-5xl mx-auto px-6 py-24">
// //         <video
// //           src="/videos/video3.mp4"
// //           autoPlay
// //           loop
// //           muted
// //           className="w-full rounded-3xl shadow-2xl"
// //         />
// //       </div>

// //       {/* CTA */}
// //       <div className="max-w-5xl mx-auto px-6 pb-32 text-center">
// //         <div className="bg-white p-12 rounded-3xl shadow">
// //           <h2 className="text-[28px] font-bold">Elevate Your Legal Practice</h2>
// //           <button className="mt-6 px-10 py-3 bg-black text-white rounded-full">
// //             Get Started
// //           </button>
// //         </div>
// //       </div>

// //     </section>
// //   );
// // };

// // export default LawyersPage;
























// import { motion } from "framer-motion";
// import {
//   Briefcase,
//   Users,
//   Clock,
//   ShieldCheck,
//   FileText,
//   Sparkles
// } from "lucide-react";

// const LawyersPage = () => {

//   const features = [
//     { icon: Briefcase, title: "Case Management", desc: "Track all legal cases in one place." },
//     { icon: Users, title: "Client Handling", desc: "Manage clients & communication easily." },
//     { icon: Clock, title: "Smart Scheduling", desc: "Never miss hearings or deadlines." },
//     { icon: ShieldCheck, title: "Secure Platform", desc: "End-to-end encrypted system." },
//     { icon: FileText, title: "Legal Docs", desc: "Organize all documents efficiently." },
//     { icon: Sparkles, title: "Productivity Boost", desc: "Automate and save time." }
//   ];

//   return (
//     <section className="bg-[#0b0b0b] text-white overflow-hidden">

//       {/* ================= HERO ================= */}
//       <div className="min-h-screen flex flex-col justify-center items-center text-center px-6">

//         <motion.h1
//           initial={{ opacity: 0, y: 80 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//           className="text-[40px] sm:text-[70px] font-extrabold leading-tight"
//         >
//           Built for
//           <span className="block text-[#cda454]">
//             Modern Lawyers
//           </span>
//         </motion.h1>

//         <p className="mt-6 max-w-2xl text-gray-400 text-lg">
//           A powerful legal workspace for cases, clients, and court workflows.
//         </p>

//       </div>

//       {/* ================= VIDEO HERO ================= */}
//       <div className="relative h-[80vh] flex items-center justify-center">

//         <video
//           src="/videos/video1.mp4"
//           autoPlay
//           loop
//           muted
//           className="absolute w-full h-full object-cover opacity-40"
//         />

//         <div className="relative z-10 text-center">
//           <h2 className="text-3xl font-bold">See It In Action</h2>
//           <p className="text-gray-300 mt-2">Experience real workflow in motion</p>
//         </div>

//       </div>

//       {/* ================= FEATURES ================= */}
//       <div className="max-w-7xl mx-auto px-6 py-32">

//         <h2 className="text-center text-4xl font-bold mb-20">
//           Everything You Need
//         </h2>

//         <div className="grid md:grid-cols-3 gap-10">

//           {features.map((item, i) => {
//             const Icon = item.icon;

//             return (
//               <motion.div
//                 key={i}
//                 whileHover={{ y: -10 }}
//                 className="group p-8 rounded-2xl border border-white/10
//                 bg-white/5 backdrop-blur-lg
//                 hover:border-[#cda454]
//                 transition-all duration-500"
//               >
//                 <Icon className="text-[#cda454] mb-4" />

//                 <h3 className="text-lg font-semibold">
//                   {item.title}
//                 </h3>

//                 <p className="text-gray-400 mt-2 text-sm">
//                   {item.desc}
//                 </p>
//               </motion.div>
//             );
//           })}

//         </div>
//       </div>

//       {/* ================= SCROLL VIDEO SECTION ================= */}
//       <div className="relative h-[120vh]">

//         <div className="sticky top-0 h-screen flex items-center justify-center">

//           <video
//             src="/videos/video2.mp4"
//             autoPlay
//             loop
//             muted
//             className="w-full h-full object-cover"
//           />

//           <div className="absolute text-center">
//             <h2 className="text-4xl font-bold">Smart Workflow</h2>
//             <p className="text-gray-300 mt-2">
//               Designed for real legal operations
//             </p>
//           </div>

//         </div>
//       </div>

//       {/* ================= INTERACTIVE CARDS ================= */}
//       <div className="max-w-6xl mx-auto px-6 py-32 grid md:grid-cols-2 gap-12">

//         {["Case Tracking", "Client Insights"].map((title, i) => (
//           <motion.div
//             key={i}
//             whileHover={{ scale: 1.05 }}
//             className="p-10 rounded-3xl border border-white/10
//             bg-gradient-to-br from-white/5 to-white/0
//             hover:shadow-[0_0_40px_rgba(205,164,84,0.3)]
//             transition-all duration-500"
//           >
//             <h3 className="text-2xl font-bold">{title}</h3>
//             <p className="text-gray-400 mt-3">
//               Powerful tools built for efficiency and performance.
//             </p>
//           </motion.div>
//         ))}

//       </div>

//       {/* ================= FINAL VIDEO ================= */}
//       <div className="max-w-6xl mx-auto px-6 pb-32">

//         <motion.video
//           whileHover={{ scale: 1.02 }}
//           src="/videos/video3.mp4"
//           autoPlay
//           loop
//           muted
//           className="w-full rounded-3xl shadow-2xl"
//         />

//       </div>

//       {/* ================= CTA ================= */}
//       <div className="text-center pb-32">

//         <h2 className="text-4xl font-bold">
//           Elevate Your Practice
//         </h2>

//         <button className="mt-6 px-10 py-4 bg-[#cda454] text-black rounded-full font-semibold hover:scale-105 transition">
//           Get Started
//         </button>

//       </div>

//     </section>
//   );
// };

// export default LawyersPage;































// import { motion } from "framer-motion";
// import {
//   Briefcase,
//   Users,
//   Clock,
//   ShieldCheck,
//   FileText,
//   Sparkles,
//   Gavel,
//   FolderKanban,
//   UserCheck,
//   CalendarClock,
//   FileSearch,
//   Scale
// } from "lucide-react";

// const LawyersPage = () => {

//   const features = [
//     {
//       icon: Briefcase,
//       title: "Case Management",
//       desc: "Track and manage all your legal cases in one structured system."
//     },
//     {
//       icon: Users,
//       title: "Client Handling",
//       desc: "Maintain complete client records and communication history."
//     },
//     {
//       icon: Clock,
//       title: "Smart Scheduling",
//       desc: "Never miss hearings or deadlines with automated reminders."
//     },
//     {
//       icon: ShieldCheck,
//       title: "Secure Platform",
//       desc: "End-to-end encrypted system for complete data protection."
//     },
//     {
//       icon: FileText,
//       title: "Legal Documentation",
//       desc: "Organize petitions, affidavits, and documents efficiently."
//     },
//     {
//       icon: Sparkles,
//       title: "Productivity Boost",
//       desc: "Reduce manual work and focus on legal strategy."
//     }
//   ];

//   const workflow = [
//     {
//       icon: FolderKanban,
//       title: "Case Lifecycle Management",
//       desc: "Track every stage of a case from filing to judgment."
//     },
//     {
//       icon: UserCheck,
//       title: "Client Case Mapping",
//       desc: "Connect clients with multiple cases instantly."
//     },
//     {
//       icon: CalendarClock,
//       title: "Court & Hearing Tracking",
//       desc: "Stay updated with schedules and deadlines."
//     },
//     {
//       icon: FileSearch,
//       title: "Document Handling",
//       desc: "Store and retrieve documents easily."
//     },
//     {
//       icon: Gavel,
//       title: "Courtroom Readiness",
//       desc: "Prepare for hearings with quick access to notes."
//     },
//     {
//       icon: Scale,
//       title: "Practice Efficiency",
//       desc: "Focus more on legal strategy."
//     }
//   ];

//   return (
//     <section className="relative w-full bg-[#f8fafc] overflow-hidden">

//       {/* HERO */}
//       <div className="max-w-6xl mx-auto px-6 pt-[140px] pb-20 text-center">
//         <motion.h1
//           initial={{ opacity: 0, y: 40 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="text-[36px] sm:text-[56px] font-extrabold text-[#111]"
//         >
//           Designed for
//           <span className="block text-[#cda454]">Modern Lawyers</span>
//         </motion.h1>

//         <p className="mt-6 max-w-2xl mx-auto text-[#555] text-[18px]">
//           A complete legal workspace to manage cases, clients, hearings, and documents.
//         </p>
//       </div>

//       {/* 🔥 VIDEO 1 (HERO SHOWCASE) */}
//       {/* 🔥 VIDEO 1 (FULL WIDTH) */}
// <div className="w-full py-24 relative">
//   <video
//     src="/videos/video2.mp4"
//     autoPlay
//     loop
//     muted
//     className="w-full h-[80vh] md:h-[95vh] object-cover"
//   />

//   {/* TEXT OVERLAY */}
//   <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
//     <div className="text-center">
//       <h2 className="text-white text-3xl font-bold">
//         See It In Action
//       </h2>
//       <p className="text-white/80 mt-2">
//         Experience real workflow in motion
//       </p>
//     </div>
//   </div>
// </div>
//       {/* FEATURE STRIP */}
//       <div className="max-w-6xl mx-auto px-6 pb-20 flex flex-wrap justify-center gap-4">
//         {["Cases", "Clients", "Hearings", "Documents", "Security"].map((item, i) => (
//           <div
//             key={i}
//             className="px-5 py-2 rounded-full border border-[#d1d5db]
//             text-sm text-[#222] hover:border-[#cda454] transition"
//           >
//             {item}
//           </div>
//         ))}
//       </div>

//       {/* FEATURES */}
//       <div className="max-w-7xl mx-auto px-6 py-20">
//         <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">

//           {features.map((item, index) => {
//             const Icon = item.icon;

//             return (
//               <motion.div
//                 key={index}
//                 whileHover={{ y: -8 }}
//                 initial={{ opacity: 0, y: 40 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5 }}
//                 className="bg-white p-6 rounded-2xl border border-[#e5e7eb]
//                 hover:border-[#cda454]
//                 shadow-sm hover:shadow-lg transition-all duration-300"
//               >
//                 <div className="w-12 h-12 rounded-full bg-[#cda454]/10 flex items-center justify-center mb-4">
//                   <Icon className="w-5 h-5 text-[#cda454]" />
//                 </div>

//                 <h3 className="text-[18px] font-semibold text-[#111] mb-2">
//                   {item.title}
//                 </h3>

//                 <p className="text-[#555] text-[15px]">
//                   {item.desc}
//                 </p>
//               </motion.div>
//             );
//           })}

//         </div>
//       </div>

//       {/* 🔥 VIDEO 2 (MID STORY SECTION) */}
// {/* 🔥 VIDEO 2 (FULL WIDTH) */}
// <div className="w-full py-24 relative">
//   <video
//     src="/videos/video2.mp4"
//     autoPlay
//     loop
//     muted
//     className="w-full h-[80vh] md:h-[95vh] object-cover"
//   />

//   {/* TEXT OVERLAY */}
//   <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
//     <div className="text-center">
//       <h2 className="text-white text-3xl font-bold">
//         Smart Workflow
//       </h2>
//       <p className="text-white/80 mt-2">
//         Designed for real legal operations
//       </p>
//     </div>
//   </div>
// </div>

//       {/* WORKFLOW */}
//       <div className="max-w-7xl mx-auto px-6 py-24">

//         <h2 className="text-[30px] sm:text-[42px] font-bold text-[#111] mb-16">
//           Built Around Real Legal Workflows
//         </h2>

//         <div className="grid md:grid-cols-2 gap-10">
//           {workflow.map((item, i) => {
//             const Icon = item.icon;

//             return (
//               <motion.div
//                 key={i}
//                 whileHover={{ y: -5 }}
//                 className="p-6 rounded-2xl border border-[#e5e7eb]
//                 bg-white hover:border-[#cda454]
//                 transition-all duration-300"
//               >
//                 <Icon className="text-[#cda454] mb-2" />
//                 <h3 className="font-semibold text-[#111]">
//                   {item.title}
//                 </h3>
//                 <p className="text-[#555] text-sm mt-1">
//                   {item.desc}
//                 </p>
//               </motion.div>
//             );
//           })}
//         </div>

//       </div>

//       {/* CTA */}
//       <div className="max-w-5xl mx-auto px-6 pb-32 text-center">
//         <div className="border border-[#e5e7eb] p-12 rounded-3xl bg-white">

//           <h2 className="text-[28px] sm:text-[36px] font-bold text-[#111]">
//             Elevate Your Legal Practice
//           </h2>

//           <p className="mt-4 text-[#555]">
//             Simplify your workflow and focus on winning cases.
//           </p>

//           <button className="mt-6 px-10 py-3 rounded-full bg-[#111] text-white hover:scale-105 transition">
//             Get Started
//           </button>

//         </div>
//       </div>

//     </section>
//   );
// };

// export default LawyersPage;


















"use client";

import { motion } from "framer-motion";
import {
  Briefcase,
  Users,
  CalendarClock,
  FileSearch,
  Scale,
  Sparkles,
  Gavel,
  FolderKanban,
  UserCheck,
} from "lucide-react";

const LawyersPage = () => {

  const features = [
    { icon: Briefcase, title: "Centralized Case Management", desc: "Maintain a single, secure space for case files, pleadings, evidence, and client records." },
    { icon: Users, title: "Team Collaboration", desc: "Assign tasks, share documents, and keep your team aligned with real-time case progress." },
    { icon: Sparkles, title: "AI-Assisted Drafting", desc: "Quickly draft petitions, notices, and legal documents, saving time for strategic work." },
    { icon: CalendarClock, title: "Smart Scheduling & Alerts", desc: "Stay on top of hearings, filings, and deadlines with smart reminders and Google Calendar sync." },
    { icon: FileSearch, title: "Live Legal Updates", desc: "Access curated judgments, legal news, and regulatory developments in one place." },
    { icon: Scale, title: "Smart Invoicing & Expenses", desc: "Manage billing, track expenses, and monitor payments with complete financial visibility." }
  ];
const workflow = [
  {
    icon: FolderKanban,
    title: "Practice Management Software",
    desc: "A complete digital workspace designed to help legal professionals organize cases, collaborate seamlessly with teams, track daily tasks, update clients in real-time, and manage invoices efficiently all from one unified and secure platform."
  },
  {
    icon: Scale,
    title: "Case Management Software",
    desc: "Streamline your case operations by managing deadlines, tracking progress, and handling complex workflows for litigation, IP matters, and other legal projects ensuring nothing is missed and everything stays under control."
  },
  {
    icon: CalendarClock,
    title: "Project Management",
    desc: "Plan, execute, and monitor both litigation and non-litigation projects with clarity. Track milestones, assign responsibilities, and ensure timely completion of every legal task with improved visibility."
  },
  {
    icon: UserCheck,
    title: "Client Management",
    desc: "Maintain strong client relationships by automatically updating clients on case progress, organizing client data, and managing billing processes all while ensuring transparency and professional communication."
  },
  {
    icon: FileSearch,
    title: "Case Updates & Alerts",
    desc: "Stay informed with real-time notifications on case activities, deadlines, and important updates, enabling you to take timely actions and never miss critical developments in your legal workflow."
  },
  {
    icon: Gavel,
    title: "Digital Case Workspace",
    desc: "Access a centralized environment to manage cases with structured timelines, detailed notes, smart labels, and organized documents allowing faster retrieval and better decision-making during critical moments."
  }
];

  return (
    <section className="bg-white  overflow-hidden">

      {/* 🔥 HERO */}
      <div className="max-w-7xl mx-auto px-6 pt-[140px] pb-24 grid lg:grid-cols-2 gap-12 items-center">

        {/* LEFT SIDE */}
        <div>
          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-[40px] sm:text-[56px] font-extrabold text-[#111] leading-tight"
          >
            Designed for Modern
            <span className="block text-[#cda454]">
              Lawyers & Law Firms
            </span>
          </motion.h1>

          <p className="mt-6 text-[#555] text-[18px]">
            JURIDENT helps lawyers and law firms manage their legal work with greater 
            efficiency and control. It brings cases, documents, deadlines, and team 
            coordination into one secure platform, making it easier to handle complex matters.
          </p>

          <p className="mt-4 text-[#666] text-[16px]">
            As firms expand, managing multiple cases, clients, and workflows becomes complex. 
            JURIDENT simplifies daily operations with better organization and collaboration.
          </p>

          {/* ✅ BUTTONS FIXED */}
          <div className="mt-8 flex gap-4 flex-wrap">
       <a
  href="/portal"
  className="px-8 py-3 rounded-full bg-[#cda454] text-white font-semibold shadow-md hover:scale-105 transition inline-block"
>
  Get Started
</a>

<a
  href="/demo"
  className="px-8 py-3 rounded-full border border-[#111] text-[#111] hover:bg-[#111] hover:text-white transition inline-block"
>
  Book Demo
</a>
          </div>
        </div>

        {/* RIGHT SIDE FLOATING CARDS */}
        {/* RIGHT FLOATING CARDS */}
<div className="relative h-[520px] hidden lg:block">

  {features.map((item, i) => {
    const Icon = item.icon;

    return (
      <motion.div
        key={i}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: i * 0.15 }}
        className="absolute bg-white border border-[#e5e7eb] p-5 rounded-2xl shadow-lg w-[260px]"
        style={{
          top: `${i * 70}px`,     // move down
          left: `${i * 50}px`     // move right (same direction) ✅
        }}
      >
        <Icon className="text-[#cda454] mb-2" />
        <h3 className="font-semibold text-[#111] text-sm">
          {item.title}
        </h3>
      </motion.div>
    );
  })}

</div>
</div>
      {/* 🎥 VIDEO SECTION */}
      <div className="w-full py-24 relative">
        <video
          src="legelteam.mp4"
          autoPlay
          loop
          muted
          className="w-full h-[80vh] md:h-[100vh] object-cover"
        />

        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-white text-3xl font-bold">
              See JURIDENT in Action
            </h2>
            <p className="text-white/80 mt-2">
              Experience real legal workflows in motion
            </p>
          </div>
        </div>
      </div>

      {/* 🚀 FEATURES */}
      {/* <div className="py-20 overflow-x-auto">
        <div className="flex gap-6 px-6 w-max">

          {features.map((item, i) => {
            const Icon = item.icon;

            return (
              <motion.div
                key={i}
                whileHover={{ y: -10 }}
                className="min-w-[300px] bg-white p-6 rounded-2xl border border-[#e5e7eb] shadow-sm hover:shadow-lg transition"
              >
                <Icon className="text-[#cda454] mb-4" />
                <h3 className="font-semibold text-[#111]">{item.title}</h3>
                <p className="text-[#555] text-sm mt-2">{item.desc}</p>
              </motion.div>
            );
          })}

        </div>
      </div> */}

      {/* ⚙️ WORKFLOW */}
      <div className="max-w-6xl mx-auto px-6 py-5">

        <h2 className="text-[36px] font-bold text-[#111] mb-16">
          How JURIDENT Supports Your Practice
        </h2>

        <div className="relative border-l border-[#e5e7eb] pl-8 space-y-12">

          {workflow.map((item, i) => {
            const Icon = item.icon;

            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                className="relative"
              >
                <div className="absolute -left-[34px] top-1 w-6 h-6 rounded-full bg-[#cda454]" />

                <Icon className="text-[#cda454] mb-2" />
                <h3 className="font-semibold text-[#111]">{item.title}</h3>
                <p className="text-[#555] text-sm">{item.desc}</p>
              </motion.div>
            );
          })}

        </div>
      </div>
      
    {/* PRODUCT SHOWCASE */}
<div className="max-w-7xl mx-auto px-6 py-28">

  <h2 className="text-[32px] sm:text-[48px] font-bold text-[#111] mb-20 text-center">
    Experience the Product
  </h2>

  <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

    {/* 🔥 MAIN IMAGE (auto height) */}
    <motion.div
      whileHover={{ scale: 1.02 }}
      className="lg:col-span-2 relative rounded-[32px] overflow-hidden group"
    >
      <img
        src="enterprise_dashboard.png"
        className="w-full h-auto object-contain rounded-[32px]"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

      <div className="absolute bottom-8 left-8">
        <h3 className="text-white text-2xl font-semibold">
          Complete Case Dashboard
        </h3>
        {/* <p className="text-white/70 mt-2">
          Manage cases, clients, and documents from one unified interface
        </p> */}
      </div>
    </motion.div>

    {/* 🔥 SIDE IMAGES */}
    <div className="flex flex-col gap-8">

      {[
        { title: "Client Management", img: "client.png" },
        { title: "Find Cases", img: "find_cases.png" },
      ].map((item, i) => (

        <motion.div
          key={i}
          whileHover={{ y: -6 }}
          className="relative rounded-[28px] overflow-hidden group"
        >
          <img
            src={item.img}
            className="w-full h-auto object-contain rounded-[28px]"
          />

          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />

          <div className="absolute bottom-5 left-5">
            <h3 className="text-white text-lg font-semibold">
              {item.title}
            </h3>
          </div>

        </motion.div>

      ))}

    </div>

  </div>
</div>


     {/* 🎯 CTA */}
{/* 🎯 CTA */}
<div className="max-w-4xl mx-auto px-6 pb-32 text-center">
  <div className="bg-white border border-[#e5e7eb] p-14 rounded-3xl shadow-xl">

    <h2 className="text-[32px] font-bold text-[#111]">
      Transform the Way You Manage Legal Work
    </h2>

    <p className="mt-4 text-[#555]">
      Bring efficiency, clarity, and control to your entire practice with JURIDENT.
      <br />
      Experience the Full Power of the Platform Free for 15 Days.
    </p>

    {/* 🔥 BUTTON GROUP */}
    <div className="mt-10 flex justify-center gap-5 flex-wrap">

      {/* Get Started */}
      <a
        href="/portal"
        className="
          px-10 py-3 rounded-full 
          bg-[#111] text-white font-medium
          transition-all duration-300
          hover:scale-105 hover:shadow-lg
          inline-block
        "
      >
        Get Started
      </a>

      {/* Contact (Smooth Scroll) */}
    <a
  href="/#help"
  className="
    group relative px-10 py-3 rounded-full font-semibold
    bg-gradient-to-r from-[#cda454] to-[#e6c57a]
    text-black
    overflow-hidden
    transition-all duration-300
    hover:scale-105 hover:shadow-[0_10px_30px_rgba(205,164,84,0.5)]
    inline-block
  "
>
  <span className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 blur-xl transition"></span>

  <span className="relative flex items-center gap-2">
    Contact
    <span className="transform transition group-hover:translate-x-1 text-black">
      →
    </span>
  </span>
</a>
    </div>

  </div>
</div>
    </section>
  );
};

export default LawyersPage;